import { Outlet } from "react-router-dom";
import Header from "../../components/Header";
import Footer from "../../components/Footer";
import Sidebar from "../../components/Sidebar";
import { LayoutProvider, useLayout } from "../../context/LayoutContext";
import { ReviewCountsProvider } from "../../context/ReviewCountsContext";
import "./mainLayout.scss";

function MainLayoutContent() {
  const { sidebarOpen, closeSidebar } = useLayout();

  return (
    <div className="layout">
      <div className="layout__row layout__row--header">
        <Header />
      </div>

      <div className="layout__row layout__row--body">
        {sidebarOpen && (
          <button
            type="button"
            className="layout__overlay"
            onClick={closeSidebar}
            aria-label="بستن منو"
          />
        )}
        <Sidebar />
        <main className="layout__content">
          <Outlet />
        </main>
      </div>

      <div className="layout__row layout__row--footer">
        <Footer />
      </div>
    </div>
  );
}

export default function MainLayout() {
  return (
    <LayoutProvider>
      <ReviewCountsProvider>
        <MainLayoutContent />
      </ReviewCountsProvider>
    </LayoutProvider>
  );
}
